import styled from '@emotion/styled';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;

  & > *:not(:last-child) {
    margin-right: 10px;
  }
`;

export const Img = styled.img`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
`;

export const TextWrapper = styled.div`
  display: flex;
  /* align-items: center; */
  justify-content: center;
  flex-direction: column;
  padding: 7px 0;
`;

export const Title = styled.p`
  font-weight: 600;
  font-size: 14px;
  margin: 0 !important;
  margin-bottom: 3px !important;
  line-height: 1;
`;

export const Text = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 1;
  margin: 0 !important;
`;
